import React from "react";

import { Box } from "@mui/material";

import storageKey from "../../../../config/storageKey";

import SwitchMain from "../../../../components/InputMain/SwitchMain";
import MainText from "../../../../components/MainText";

export default function PersonalizationConfig() {
  const [bottomMargin, setBottomMargin] = React.useState(
    window.localStorage.getItem(storageKey.DISABLE_BOTTOM_PAD) ? false : true
  );

  const handleChangeBottomMargin = (value: boolean) => {
    if (value) {
      window.localStorage.removeItem(storageKey.DISABLE_BOTTOM_PAD);
    } else {
      window.localStorage.setItem(storageKey.DISABLE_BOTTOM_PAD, "true");
    }

    setBottomMargin(value);
  };

  React.useEffect(() => {}, []);

  return (
    <Box mt={3}>
      <MainText size="subtitle">Personalização</MainText>

      <Box mt={2}>
        <SwitchMain
          name="Margem Inferior da Barra de Navegação"
          checked={bottomMargin}
          onChange={handleChangeBottomMargin}
        />
      </Box>
    </Box>
  );
}
